import { useSessao } from '@/modulos/sessao/consultas';

/**
 * O que a pessoa pode fazer nas integrações (0104), pelas licenças da sessão:
 * cada ação só aparece para quem tem a licença da rota dela (H54).
 */
export function usePermissoesDaIntegracao() {
  const sessao = useSessao();
  const p = sessao.data?.permissoes ?? [];
  return {
    usuarioId: sessao.data?.usuarioId ?? null,
    nome: sessao.data?.nome ?? '',
    configurar: p.includes('integracao.configurar'),
    aprovar: p.includes('integracao.aprovar_mestre'),
    importar: p.includes('integracao.importar'),
    exportar: p.includes('integracao.exportar'),
    conciliar: p.includes('integracao.conciliar'),
    /* 0108: lançar título e baixa (a plataforma mestre) e escrever em contingência. */
    gravarTitulo: p.includes('titulo.gravar'),
    contingencia: p.includes('integracao.contingencia'),
  };
}
